<template>
  <div class="accountManagement">

    <!-- 查询区内容 -->
    <div class="queryArea">
      <div>
        <el-input v-model="parameter.config_name" placeholder="请输入配置名称" class="queryArea_input" />
        <!-- <el-select
          v-model="parameter.platformId"
          class="launch"
          filterable
          placeholder="选择平台"
        >
          <el-option
            v-for="item in platforms"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select> -->
        <el-button
          type="primary"
          icon="el-icon-search"
          style="margin-left:10px"
          @click="search"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="reset"
        >重置</el-button>
      </div>
      <div>
        <el-button icon="el-icon-circle-plus" type="success" @click="establish">新增广告主</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      tooltip-effect="dark"
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="config_name"
        label="配置名称"
        width="300"
        align="center"
      />
      <el-table-column
        label="配置类型"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.config_type == 'adq_account_hour'">腾讯广告主小时数据</div>
          <div v-if="scope.row.config_type == 'ocean_account_hour'">巨量广告主小时数据</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="standard"
        label="指标"
        width="300"
        align="center"
      />
      <el-table-column
        prop="interval"
        label="监控间隔(分钟)"
        width="200"
        align="center"
      />
      <!-- 最低标准值 -->
      <el-table-column
        prop="standard_min"
        label="最低标准值"
        align="center"
      />

      <!-- 是否打开最低标准 -->
      <el-table-column
        prop="is_open_min"
        label="最低标准"
        align="center"
      >
        <template #default="scope">
          <span :style="{ color: scope.row.is_open_min === 1 ? 'green' : 'red' }">
            {{ scope.row.is_open_min === 1 ? '打开' : '关闭' }}
          </span>
        </template>
      </el-table-column>

      <!-- 最高标准值 -->
      <el-table-column
        prop="standard_max"
        label="最高标准值"
        align="center"
      />

      <!-- 是否打开最高标准 -->
      <el-table-column
        prop="is_open_max"
        label="最高标准"
        align="center"
      >
        <template #default="scope">
          <span :style="{ color: scope.row.is_open_max === 1 ? 'green' : 'red' }">
            {{ scope.row.is_open_max === 1 ? '打开' : '关闭' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="edit(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleteall(scope.row.id)">删除</el-button>
          <!-- <el-button type="primary" size="mini" @click="addsubset(scope.row)">增加子集</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="广告主"
      :visible.sync="dialogVisible"
      width="30%"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <atlisdialog ref="atewaasr" @close="close" />
    </el-dialog>
  </div>
</template>

<script>
import atlisdialog from './components/atlisdialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { atlaslistrrrr, adevaluationconfigdelete } from '@/api/taobaoLink.js'
export default {
  components: {
    atlisdialog,
    PaginationRight
  },
  data() {
    return {
      parameter: {
        config_name: null,
        platformId: null,
        page: 1,
        page_size: 10
      },
      platforms: [], // 平台数据的
      tableData: [], // 列表数据
      dialogVisible: false, // 新增图集弹窗
      total: null// 总页数
    }
  },
  watch: {

  },
  created() {
    // this.strategylist()
    this.getweatlas()
  },
  mounted() {

  },
  methods: {
    // 获取策略列表
    // async strategylist() {
    //   const data = await strategyPlatform()
    //   this.platforms = data.data.list
    //   console.log('data', data)
    // },
    // 获取图集列表
    async getweatlas() {
      const data = await atlaslistrrrr(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data列表', data)
    },
    // 分页
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getweatlas()
    },
    fetchCurrentPage(e) {
      this.parameter.page = 1
      this.parameter.page = e
      this.getweatlas()
    },
    // 新增
    establish() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.atewaasr.send(1)
      })
    },
    edit(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.atewaasr.send(2, item)
      })
    },
    // 新增关闭完的回调
    close() {
      this.dialogVisible = false
      this.getweatlas()
    },
    // 删除
    deleteall(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        adevaluationconfigdelete({
          id: id
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getweatlas()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 新增子集
    addsubset(item) {
      console.log('item', item)
      this.$router.push({ path: '/addsubset/index', query: { appId: item.appId, id: item.id, platformId: item.platformId }})
    },
    // 重置
    reset() {
      this.parameter.page = 1
      this.parameter.page_size = 10
      this.parameter.config_name = null
      this.parameter.platformId = null
      this.getweatlas()
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.parameter.page_size = 10
      this.getweatlas()
    },
    handleClose() {
      this.getweatlas()
    }
  }
}
</script>
<style scoped>
.accountManagement{
   padding: 30px 60px;
}

.queryArea_input{
  width: 200px;
  margin-right: 10px;
}
.titip{
    width: 152px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    overflow: hidden;
}
.queryArea{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
